export default [
  {
    header: 'Risk + Procedure',
    icon: 'GridIcon',
    route: 'risk-procedure',
    title: 'Risk + Procedure'
  },
]
